import Cookies from "js-cookie";
import { parseJSON } from "../../util/index";
import { getPointUserInfo } from "@/api/pointsMall";

const pointsMall = {
  state: {
    pmUserInfo: "",
  },
  mutations: {
    SET_PM_USER_INFO(state, info) {
      state.pmUserInfo = info;
      localStorage.setItem("pmUserInfo", JSON.stringify(info));
    },
    DEL_PM_USER_INFO(state, info) {
      state.pmUserInfo = {};
      localStorage.setItem("pmUserInfo", "{}");
    },
  },
  actions: {
    savePMUserInfo({ commit }, data) {
      commit("SET_PM_USER_INFO", data);
    },
    delPMUserInfo() {
      commit("DEL_PM_USER_INFO");
    },
    async updatePMUserInfo({ commit, state }) {
      const data = await getPointUserInfo();
      commit("SET_PM_USER_INFO", Object.assign(state.pmUserInfo ,data));
    },
  },
  getters: {
    pmUserInfo(state) {
      return state.pmUserInfo || parseJSON(localStorage.getItem("pmUserInfo"));
    },
  },
};
export default pointsMall;



// WEBPACK FOOTER //
// src/store/modules/pointsMall.js